<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="queryForm.xnbm" filterable placeholder="学年" style="width:200px" @change="classOption">
                <el-option v-for="item in xnInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.deptCode" filterable placeholder="系部名称" style="width:18%" @change="changeDept" multiple clearable>
                <el-option v-for="item in deptInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.majorCode" filterable placeholder="专业名称" style="width:18%" @change="classOption" multiple clearable>
                <el-option v-for="item in majorInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.classCode" filterable placeholder="班级名称" style="width:18%" multiple clearable>
                <el-option v-for="item in classInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.statusCode" filterable placeholder="学籍异动状态" style="width:18%" multiple clearable>
                <el-option v-for="item in statusInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray" style="margin-left: 10px"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
        </div>

        <div class="filter-container">
            <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
            <div class="checkItem_label">请选择要显示的统计项目：</div>
            <div class="checkItem">
                <el-checkbox-group v-model="checkedItems" @change="handlecheckedItemsChange">
                    <el-checkbox v-for="item in itemOption" :label="item" :key="item">{{item}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div style="width:100%;height:20px;">
            </div>
        </div>

        <el-table :data="tableData" @curplus-outlinerent-change="handleCurrentChange" v-loading.body="tableLoading" show-summary :summary-method="getSummaries"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="80" align="center">
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column v-if="deptShow==true" label="系部名称" prop="deptName" align="center" min-width="20%"></el-table-column>
            <el-table-column v-if="majorShow==true" label="专业名称" prop="majorName" align="center" min-width="20%"></el-table-column>
            <el-table-column v-if="classShow==true" label="班级名称" prop="className" align="center" min-width="20%"></el-table-column>
            <el-table-column label="学生人数" prop="stuNumber" align="center" min-width="10%"></el-table-column>
            <el-table-column label="学籍异动人次" prop="statusNumber" align="center" min-width="10%"></el-table-column>
            <el-table-column label="学籍异动详情" align="center" min-width="10%">
                <template slot-scope="scope">
                    <el-button size="small" @click="showInfo(scope.row);" type="primary">
                        <i class="el-icon-tickets"></i>&nbsp;详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div> -->

        <!--显示学籍异动详情-->
        <el-dialog :title="statusTitle" :visible.sync="statusDialogVisiable" v-if="statusDialogVisiable" width="36%" top="180px" append-to-body>
            <el-table :data="statusTableData" v-loading.body="tableLoading" show-summary :summary-method="getSummaries"
                element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="statusTableHeight" ref="statusTable">
                <el-table-column label="序号" width="80" align="center">
                    <template slot-scope="scope">
                        <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="异动类别" prop="changeName" align="center" min-width="20%"></el-table-column>
                <el-table-column label="人次" prop="statusNumber" align="center" min-width="20%"></el-table-column>
            </el-table>
            <div style="width:100%;height:20px;">
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import { confirmMsg } from "utils/message";

    export default {
        data() {
            return {
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnbm: '',
                    deptCode: '',
                    majorCode: '',
                    classCode: '',
                    statusCode: '',
                },
                xnInfo: [], //学年学期下拉框
                deptInfo: [], //系部下拉框
                majorInfo: [], //专业下拉框
                classInfo: [], //班级下拉框
                statusInfo: [], //学籍异动下拉框
                tableData: [],
                currentXnxq: null,
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: null,
                mainTableHeight: 500,
                statusTableHeight: 500,
                formSubmiting: false,
                editType: null,

                timer: '', //时间戳,点击重新加载子页面
                selectedId: null,
                type: null,
                statusDialogVisiable: false,
                activeName: '1', //默认选中第一个tab
                tabnum: '1', //加载tab
                isIndeterminate: true,
                checkAll: false,
                checkedItems: [],
                itemOption: [],
                deptShow: true,
                majorShow: true,
                classShow: true,
                statusTableData: [],
                statusTotal: null,
                statusTitle: '详情',
            };
        },
        created() {
            this.initParam();
        },
        mounted() {
            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 90;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 90;
                };
            });
            this.itemOption = ['系部', '专业', '班级'];
            this.checkedItems = ['系部', '专业', '班级'];
        },
        provide() {
            return {
                showOperation: this.showOperation,
            }
        },
        methods: {
            initParam(){
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.basicReport.statistics.yearOption({
                    data: paramMap
                }).then(response => {
                    this.xnInfo = response.data.data.comboData;
                    this.queryForm.xnbm = this.xnInfo[0].comboValue;
                    this.queryList();
                }).catch(error => {
                    console.log(error);
                });
                this.$api.basicReport.statistics.deptOption({
                    data: paramMap
                }).then(response => {
                    this.deptInfo = response.data.data.comboData;
                    //alert(JSON.stringify(response.data.data));
                }).catch(error => {
                    console.log(error);
                });

                this.majorOption();
                this.classOption();

                this.$api.basicReport.statistics.statusOption({
                    data: paramMap
                }).then(response => {
                    this.statusInfo = response.data.data.comboData;
                    //alert(JSON.stringify(response.data.data));
                }).catch(error => {
                    console.log(error);
                });
            },
            changeDept(){
                this.majorOption();
                this.classOption();
            },
            majorOption(){
                const paramMap = {
                    'deptCode': this.queryForm.deptCode+""
                }
                this.$api.basicReport.statistics.majorOption({
                    data: paramMap
                }).then(response => {
                    this.majorInfo = response.data.data.comboData;
                    //alert(JSON.stringify(response.data.data));
                }).catch(error => {
                    console.log(error);
                });
            },
            classOption(){
                const paramMap = {
                    'xnbm': this.queryForm.xnbm,
                    'deptCode': this.queryForm.deptCode+"",
                    'majorCode': this.queryForm.majorCode+"",
                }
                this.$api.basicReport.statistics.classOption({
                    data: paramMap
                }).then(response => {
                    this.classInfo = response.data.data.comboData;
                }).catch(error => {
                    console.log(error);
                });
            },
            handleCheckAllChange(val) {
                this.checkedItems = val ? this.itemOption : [];
                this.isIndeterminate = false;
            },
            handlecheckedItemsChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.itemOption.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.itemOption.length;
                if(this.checkedItems.indexOf("系部")>-1){
                    this.deptShow = true;
                }else{
                    this.deptShow = false;
                }
                if(this.checkedItems.indexOf("专业")>-1){
                    this.majorShow = true;
                }else{
                    this.majorShow = false;
                }
                if(this.checkedItems.indexOf("班级")>-1){
                    this.classShow = true;
                }else{
                    this.classShow = false;
                }
                this.queryList();
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;
                const paramMap = {
                    'pageNum': this.queryForm.pageNum,
                    'rowNum': this.queryForm.rowNum,
                    'xnbm': this.queryForm.xnbm,
                    'deptCode': this.queryForm.deptCode+"",
                    'majorCode': this.queryForm.majorCode+"",
                    'classCode': this.queryForm.classCode+"",
                    'statusCode': this.queryForm.statusCode+"",
                    'checkedItems': this.checkedItems+"",
                }

                this.$api.basicReport.statistics.basicList({
                    data: paramMap,
                }).then((response) => {
                    this.tableData = response.data.data.list;
                    this.statusTotal = response.data.data.total;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            showInfo(row){
                this.queryList();
                this.queryStatusList(row);
                this.statusDialogVisiable = true;
            },
            queryStatusList(row){
                this.tableLoading = true;
                const paramMap = {
                    'pageNum': this.queryForm.pageNum,
                    'rowNum': this.queryForm.rowNum,
                    'xnbm': this.queryForm.xnbm,
                    'deptCode': row.deptCode,
                    'majorCode': row.majorCode,
                    'classCode': row.classCode,
                    'statusCode': this.queryForm.statusCode+"",
                    'checkedItems': this.checkedItems+"",
                }
                this.$api.basicReport.statistics.statusList({
                    data: paramMap,
                }).then((response) => {
                    this.statusTableData = response.data.data.list;
                    this.total = response.data.data.total;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            getSummaries(param){
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    if (column.property === "stuNumber" || column.property === "statusNumber") {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                            //sums[index] += ' 人';
                        } else {
                            sums[index] = '';
                        }
                    }
                });

                return sums;
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.xnxqbm = '';
                this.queryForm.deptCode = '';
                this.queryForm.majorCode = '';
                this.queryForm.classCode = '';
                this.queryForm.statusCode = '';
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               //this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            handleClick(tab) {
                this.tabnum = tab.name;
            },
            showOperation(tabItem) {
                this.timer = new Date().getTime();
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
        },
    };
</script>

<style scoped>
.components-container {
    margin-bottom: 0px;
}
.checkItem_label{
    float:left;
}
.checkItem{
    float:left;
    margin-left:20px;
}
.components-container /deep/ .el-table__body-wrapper {
    height: calc(100% - 96px) !important;
}
</style>



// WEBPACK FOOTER //
// tempHighBasicReport.vue?4412b2ce